<ng-template #template>
  <div class="col-12" [hidden]="hidden">
    <div class="card" style="background-color: #0e0e29">
      <div class="card-body">
        <h3 style="color: white">{{ data?.title }}</h3>
        <div style="display: block">
          <canvas
            id="chart1"
            baseChart
            [datasets]="barChartData"
            [labels]="barChartLabels"
            [options]="barChartOptions"
            [colors]="lineChartColors"
            [chartType]="barChartType"
          ></canvas>
        </div>
      </div>
    </div>
  </div>
</ng-template>
